
export const WINNERS = [
  { town: 'town.almaty', name: 'Асель К.' },
  { town: 'town.almaty', name: 'Эльмира Д.' },
  { town: 'town.astana', name: 'Рахат К.' },
  { town: 'town.karaganda', name: 'Александр Е.' },
  { town: 'town.astana', name: 'Асия Т.' },
  { town: 'town.almaty', name: 'Самат Т.' },
  { town: 'town.atyrau', name: 'Раушан Р.' },
  { town: 'town.almaty', name: 'Талгат К.' },
  { town: 'town.uralsk', name: 'Майра Н.' },
  { town: 'town.kordaiDistrict', name: 'Ниязбек М' }
];
